export const PAGE_SIZE = 5;
export const columnsWidth = {
  readingType: 360,
  assign: 172,
};

export type PodSection =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'outside'
  | null;

export const POD_SECTION_CONFIG: Record<
  NonNullable<PodSection> | 'none',
  {
    borderColor: string;
    textColor: string;
    avatarBg: string;
    avatarTextColor: string;
  }
> = {
  primary: {
    borderColor: 'var(--color-primary-hover)',
    textColor: 'var(--color-primary)',
    avatarBg: 'var(--ant-purple-2)',
    avatarTextColor: 'var(--color-primary)',
  },
  secondary: {
    borderColor: 'var(--ant-geekblue-4)',
    textColor: 'var(--color-info-text)',
    avatarBg: 'var(--ant-geekblue-2)',
    avatarTextColor: 'var(--ant-geekblue-6)',
  },
  tertiary: {
    borderColor: 'var(--ant-cyan-4)',
    textColor: 'var(--ant-cyan-6)',
    avatarBg: 'var(--ant-cyan-2)',
    avatarTextColor: 'var(--ant-cyan-6)',
  },
  outside: {
    borderColor: 'var(--color-grey-6)',
    textColor: 'var(--ant-color-text-tertiary)',
    avatarBg: 'var(--color-text-placeholder)',
    avatarTextColor: 'var(--white)',
  },
  none: {
    borderColor: 'var(--color-grey-6)',
    textColor: 'var(--ant-color-text-tertiary)',
    avatarBg: 'var(--color-text-placeholder)',
    avatarTextColor: 'var(--white)',
  },
};

export const ROW_BORDER_WIDTH = '0.3125rem'; // 5px
export const SLA_URGENT_BORDER_COLOR = 'var(--color-error)';
export const SLA_AVATAR_BG = 'var(--ant-red-2)';
export const SLA_AVATAR_TEXT_COLOR = 'var(--ant-red-5)';
